<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one">
        <div>
          <div class="title_div">
            <span class="title-span">发布日期:</span>
            <el-date-picker
              @change="zxStartChange"
              v-model="hdParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="zxEndChange"
              v-model="hdParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="creatDialogVisible = true"
              >新建资讯
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="hdList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="封面图"
                width="200"
                align="center"
              >
                <template slot-scope="scope">
                  <el-image :src="titleUrl + scope.row.filePath"></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="标题" align="center">
              </el-table-column>
              <el-table-column prop="source" label="来源" align="center">
              </el-table-column>
              <el-table-column prop="address" label="发布日期" align="center">
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column prop="address" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.postStatus == '0'"
                    type="text"
                    size="medium"
                    @click="changeStatus(scope.row)"
                    >发布
                  </el-button>
                  <el-button
                    v-if="scope.row.postStatus == '1'"
                    type="text"
                    size="medium"
                    @click="changeStatus(scope.row)"
                    >取消发布
                  </el-button>
                  <el-button
                    type="text"
                    size="medium"
                    @click="edieHd(scope.row.id)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="medium"
                    @click="deletHd(scope.row.id)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="hdSizeChange"
              @current-change="hdCurrentChange"
              :current-page="hdResult.current"
              :page-size="hdResult.size"
              layout="total,prev, pager, next, sizes"
              :total="hdResult.total"
               :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>
      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="新建资讯"
      :visible.sync="creatDialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">资讯标题:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="hdCreatParams.title"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span">资讯来源:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="hdCreatParams.source"
        ></el-input>
      </div>
      <!--      <div class="dialog-div">-->
      <!--        <span class="title-span">开始日期:</span>-->
      <!--        <el-date-picker-->
      <!--          v-model="hdCreatParams.dateStart"-->
      <!--          size="small"-->
      <!--          class="title-date1"-->
      <!--          type="date"-->
      <!--          format="yyyy-MM-dd"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="选择开始日期">-->
      <!--        </el-date-picker>-->
      <!--      </div>-->
      <!--      <div class="dialog-div">-->
      <!--        <span class="title-span">结束日期:</span>-->
      <!--        <el-date-picker-->
      <!--          v-model="hdCreatParams.dateEnd"-->
      <!--          size="small"-->
      <!--          class="title-date1"-->
      <!--          type="date"-->
      <!--          format="yyyy-MM-dd"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="选择开始日期">-->
      <!--        </el-date-picker>-->
      <!--      </div>-->
      <div class="dialog-div" style="height: 325px">
        <span class="title-span">资讯内容:</span>
        <quill-editor
          class="quillEditor"
          v-model="hdCreatParams.content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        >
        </quill-editor>
      </div>
      <div class="dialog-div" style="height: 160px">
        <span class="title-span" style="float: left"
          >封面照片
          <el-tooltip
            class="item"
            effect="dark"
            content="图片大小不能超过 5MB,图片最优宽度为690px,最优高度为240px,宽高最优比例为23：8"
            placement="top-start"
          >
            <i class="el-icon-info iconClass"></i> </el-tooltip
          >:</span
        >
        <el-upload
          style="float: left"
          class="upload-demo"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="creatHandleAvatarSuccess"
          :before-upload="creatBeforeAvatarUpload"
        >
          <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="creatDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑资讯"
      :visible.sync="editDialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">资讯标题:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="hdEditParams.title"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span">资讯来源:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="hdEditParams.source"
        ></el-input>
      </div>
      <!--      <div class="dialog-div">-->
      <!--        <span class="title-span">开始日期:</span>-->
      <!--        <el-date-picker-->
      <!--          v-model="hdEditParams.dateStart"-->
      <!--          size="small"-->
      <!--          class="title-date1"-->
      <!--          type="date"-->
      <!--          format="yyyy-MM-dd"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="选择开始日期">-->
      <!--        </el-date-picker>-->
      <!--      </div>-->
      <!--      <div class="dialog-div">-->
      <!--        <span class="title-span">结束日期:</span>-->
      <!--        <el-date-picker-->
      <!--          v-model="hdEditParams.dateEnd"-->
      <!--          size="small"-->
      <!--          class="title-date1"-->
      <!--          type="date"-->
      <!--          format="yyyy-MM-dd"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="选择开始日期">-->
      <!--        </el-date-picker>-->
      <!--      </div>-->
      <div class="dialog-div" style="height: 325px">
        <span class="title-span">资讯内容:</span>
        <quill-editor
          class="quillEditor"
          v-model="hdEditParams.content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        >
        </quill-editor>
      </div>
      <div class="dialog-div" style="height: 160px">
        <span class="title-span" style="float: left"
          >封面照片
          <el-tooltip
            class="item"
            effect="dark"
            content="图片大小不能超过 5MB,图片最优宽度为690px,最优高度为240px,宽高最优比例为23：8"
            placement="top-start"
          >
            <i class="el-icon-info iconClass"></i> </el-tooltip
          >:</span
        >
        <el-upload
          style="float: left"
          class="upload-demo"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="editHandleAvatarSuccess"
          :before-upload="creatBeforeAvatarUpload"
        >
          <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editCommit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { globelurl, posturl } from "../../api/axios";
import {
  addAntEvent,
  deleteAntEvent,
  getAntEventById,
  getEventPageList,
  updateAntEvent,
  updatePostStatus,
} from "../../api/OperationManagement";

export default {
  name: "1InformationManagement",
  data() {
    return {
      activeName: "one",
      upLoadUrl: posturl,
      titleUrl: globelurl,
      headers: { "X-Access-Token": sessionStorage.token },
      hdParams: {
        eventType: "2",
        createDateStart: "",
        createDateEnd: "",
        pageNo: 1,
        pageSize: 10,
      },
      hdResult: {},
      hdList: [],
      creatDialogVisible: false,
      editDialogVisible: false,
      creatImageUrl: "",
      editImageUrl: "",
      hdCreatParams: {
        title: "",
        source: "",
        dateStart: "",
        dateEnd: "",
        filePath: "",
        content: "",
        eventType: "2",
      },
      hdEditParams: {
        title: "",
        source: "",
        dateStart: "",
        dateEnd: "",
        filePath: "",
        content: "",
        eventType: "2",
      },
      editorOption: {
        placeholder: "请在这里输入资讯内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
            ["blockquote", "code-block"], //引用，代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], //列表
            [{ script: "sub" }, { script: "super" }], // 上下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: [] }], //字体
            [{ align: [] }], //对齐方式
            ["clean"], //清除字体样式
            ["image", "video"], //上传图片、上传视频
          ],
        },
      },
    };
  },
  mounted() {
    this.getEventPageList(this.hdParams);
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        // this.$router.push('/OperationManagement/1InformationManagement');
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    hdSizeChange(newSize) {
      this.hdParams.pageSize = newSize;
      this.getEventPageList(this.hdParams);
    },
    hdCurrentChange(newPage) {
      this.hdParams.pageNo = newPage;
      this.getEventPageList(this.hdParams);
    },
    //资讯开始时间改变
    zxStartChange(val) {
      if (
        this.hdParams.createDateStart &&
        this.hdParams.createDateEnd &&
        new Date(this.hdParams.createDateStart).getTime() >
          new Date(this.hdParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hdParams.pageNo = 1;
      this.getEventPageList(this.hdParams);
    },
    //资讯结束时间改变
    zxEndChange(val) {
      if (
        this.hdParams.createDateStart &&
        this.hdParams.createDateEnd &&
        new Date(this.hdParams.createDateStart).getTime() >
          new Date(this.hdParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hdParams.pageNo = 1;
      this.getEventPageList(this.hdParams);
    },
    //获取资讯列表
    getEventPageList(params) {
      getEventPageList(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.hdResult = res.data.result;
            this.hdList = res.data.result.records;
          } else {
            this.hdResult = res.data.result;
            this.hdList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //新建资讯图片上传
    creatHandleAvatarSuccess(res, file) {
      this.hdCreatParams.filePath = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    //编辑资讯图片上传
    editHandleAvatarSuccess(res, file) {
      this.hdEditParams.filePath = res.result.pathList[0];
      this.editImageUrl = globelurl + res.result.pathList[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //新建资讯富文本编辑器
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    //新建资讯提交
    createCommit() {
      if (this.hdCreatParams.title == "") {
        this.$message.error("请输入资讯标题");
      } else if (this.hdCreatParams.source == "") {
        this.$message.error("请输入资讯来源");
      } else if (this.hdCreatParams.content == "") {
        this.$message.error("请输入资讯详情");
      } else if (this.hdCreatParams.filePath == "") {
        this.$message.error("请选择资讯封面图片");
      } else {
        addAntEvent(this.hdCreatParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建资讯成功");
              this.creatDialogVisible = false;
              this.getEventPageList(this.hdParams);
              this.hdCreatParams = {
                title: "",
                source: "",
                dateStart: "",
                dateEnd: "",
                filePath: "",
                content: "",
              };
              this.creatImageUrl = "";
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },

    //获取资讯信息
    edieHd(val) {
      console.log(val);
      getAntEventById({ id: val }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.editDialogVisible = true;
            this.hdEditParams.id = res.data.result.id;
            this.hdEditParams.title = res.data.result.title;
            this.hdEditParams.source = res.data.result.source;
            this.hdEditParams.dateStart = res.data.result.dateStart;
            this.hdEditParams.dateEnd = res.data.result.dateEnd;
            this.hdEditParams.content = res.data.result.content;
            this.hdEditParams.filePath = res.data.result.filePath;
            this.editImageUrl = globelurl + res.data.result.filePath;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //编辑资讯
    editCommit() {
      if (this.hdEditParams.title == "") {
        this.$message.error("请输入资讯标题");
      } else if (this.hdEditParams.source == "") {
        this.$message.error("请输入资讯来源");
      } else if (this.hdEditParams.content == "") {
        this.$message.error("请输入资讯详情");
      } else if (this.hdEditParams.filePath == "") {
        this.$message.error("请选择资讯封面图片");
      } else {
        updateAntEvent(this.hdEditParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建资讯成功");
              this.editDialogVisible = false;
              this.getEventPageList(this.hdParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },

    //修改资讯发布状态
    changeStatus(row) {
      this.$confirm("是否修改资讯发布状态", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row);
          //  发布type:0  取消发布 type:1
          let type = row.postStatus == "0" ? "0" : "1";
          updatePostStatus({ id: row.id, type }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.getEventPageList(this.hdParams);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },

    //删除资讯
    deletHd(id) {
      this.$confirm("此操作将永久删除该资讯, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAntEvent({ id: id }).then((res) => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: "查无数据",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getEventPageList(this.hdParams);
              }
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 500px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.dialog-div {
  margin: 20px 50px;
}

.quillEditor {
  height: 220px;
  margin: 10px 20px;
  display: inline-block;
}
</style>

<style>
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-left: 20px;
}

.upload-demo .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 340px !important;
  height: 120px !important;
  line-height: 120px;
  text-align: center;
}

.upload-demo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;

}

.avatar {
  width: 340px;
  height: 120px;
  display: block;
}
.iconClass {
  position: relative;
  top: 1px;
  left: -3px;
}
</style>